// Importera funktioner från Firebase SDK
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth'; 

// Firebase-konfigurationen från Firebase Console
const firebaseConfig = {
    apiKey: "AIzaSyAhICGqLaIsNZ9XCwgcxzkZV405C-ZHNdg",
    authDomain: "nynna-tool.firebaseapp.com",
    projectId: "nynna-tool",
    storageBucket: "nynna-tool.firebasestorage.app",
    messagingSenderId: "302230317740",
    appId: "1:302230317740:web:b85d212b8d8a191fb78d09"
  };


// Initiera Firebase
const app = initializeApp(firebaseConfig);

// Initiera Firestore
const db = getFirestore(app);

// Initiera Firebase Authentication
const auth = getAuth(app);

export { db, auth, app };



  
